import { iterable, mix, patch } from "@chorda/core";
const isColumn = (v) => {
    return v.content != null;
};
export const ColumnLayout = (elements) => {
    return mix({
        css: 'columns',
        defaultItem: {
            css: 'column',
            reactions: {
                column: (v) => isColumn(v) ? { components: { content: v.content }, css: v.css } : { components: { content: v } }
            }
        },
        reactions: {
            columns: (v) => patch({ items: v })
        }
    }, {
        injections: {
            columns: () => iterable(elements, 'column')
        }
    });
};
export const Column = (props) => {
    return props;
};
